import { createAsyncThunk } from '@reduxjs/toolkit';

import { IScheduleFullEvent, IUserScheduleData } from '.';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { ApiPaths } from '../../../api/APIPaths';

export type TGetUserSchedule = {
  userId: string;
  startDate: string;
  endDate: string;
  courseId?: string;
  studentId?: string;
  tutorId?: string;
};

export type TGetScheduleById = {
  sectionId: string;
};

const apiDataProvider = new APIDataProvider();

export const getUserSchedulesAsUser = createAsyncThunk(
  '/schedule/getByUserId',
  async (data: TGetUserSchedule) => {
    let path = `${ApiPaths.schedule}/list/${data.userId}?userId=${data.userId}&startDate=${data.startDate}&endDate=${data.endDate}`;

    if (data.courseId) {
      path += `&courseId=${data.courseId}`;
    }

    if (data.studentId) {
      path += `&studentId=${data.studentId}`;
    }

    if (data.tutorId) {
      path += `&tutorId=${data.tutorId}`;
    }

    const response = await apiDataProvider.get<TApiResponse<IUserScheduleData>>(
      path
    );

    return response.data;
  }
);

export const getScheduleByIdAsUser = createAsyncThunk(
  '/schedule/getOneBySectionId',
  async (data: TGetScheduleById) => {
    const path = `${ApiPaths.schedule}/${data.sectionId}?sectionId=${data.sectionId}`;

    const response = await apiDataProvider.get<
      TApiResponse<IScheduleFullEvent>
    >(path);

    return response.data;
  }
);
